import { render, staticRenderFns } from "./ScoreSlideOver.vue?vue&type=template&id=0d277bcb"
import script from "./ScoreSlideOver.vue?vue&type=script&lang=js"
export * from "./ScoreSlideOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports